module.exports = __webpack_public_path__ + "img/laptop-screen-active.3aa0f960.svg";